import * as React from "react";
import { Fragment } from "react";
import "./VerticalFormTemplate.scss";

const VerticalFormTemplate = (props: any) => {
  const { uiSchema } = props;
  return (
    <div >
      {/* Keep below code for future reference in case if we want title. */}
      {props.title && (
        <div
          className={`my-2 ${uiSchema?.["ui:options"]?.["label"]?.["classNames"] ?? "font-semibold"}`}
        >
          {props.title}
        </div>
      )}
      <div className={`${uiSchema?.["ui:options"]?.["body"]?.["classNames"]}`}>
      <div className="p-fluid p-formgrid p-grid">
        {props.properties.map((element: any) => (
          <Fragment key={element.name}>{element.content}</Fragment>
        ))}
      </div>
      </div>
    </div>
  );
};

export default VerticalFormTemplate;
